/**
 * LanguageIcon — sanitized from `assets/newSvg/language.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function LanguageIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M17,10.5 C17.7796706,10.5 18.4204457,11.0949121 18.4931332,11.8555442 L18.5,12 L18.5,12.5 L19.5,12.5 C20.5543909,12.5 21.4181678,13.31585 21.4945144,14.3507339 L21.5,14.5 L21.5,17.5 C21.5,18.5543909 20.68415,19.4181678 19.6492661,19.4945144 L19.5,19.5 L18.5,19.5 L18.5,20 C18.5,20.8284 17.8284,21.5 17,21.5 C16.2203294,21.5 15.5795543,20.9050879 15.5068668,20.1444558 L15.5,20 L15.5,19.5 L14.5,19.5 C13.4456091,19.5 12.5818322,18.68415 12.5054856,17.6492661 L12.5,17.5 L12.5,14.5 C12.5,13.4456091 13.31585,12.5818322 14.3507339,12.5054856 L14.5,12.5 L15.5,12.5 L15.5,12 C15.5,11.1716 16.1716,10.5 17,10.5 Z M5,14.5 C5.82843,14.5 6.5,15.1716 6.5,16 L6.5,17 C6.5,17.2761 6.72386,17.5 7,17.5 L10,17.5 C10.8284,17.5 11.5,18.1716 11.5,19 C11.5,19.8284 10.8284,20.5 10,20.5 L7,20.5 C5.067,20.5 3.5,18.933 3.5,17 L3.5,16 C3.5,15.1716 4.17157,14.5 5,14.5 Z M15.5,15 L14.5,15 L14.5,17 L15.5,17 L15.5,15 Z M19.5,15 L18.5,15 L18.5,17 L19.5,17 L19.5,15 Z M9.5,2.5 C10.3284,2.5 11,3.17157 11,4 C11,4.82843 10.3284,5.5 9.5,5.5 L5.5,5.5 L5.5,6.5 L9,6.5 C9.82843,6.5 10.5,7.17157 10.5,8 C10.5,8.82843 9.82843,9.5 9,9.5 L5.5,9.5 L5.5,10.5 L10,10.5 C10.8284,10.5 11.5,11.1716 11.5,12 C11.5,12.8284 10.8284,13.5 10,13.5 L4.1,13.5 C3.21635,13.5 2.5,12.7837 2.5,11.9 L2.5,4.1 C2.5,3.21635 3.21634,2.5 4.1,2.5 L9.5,2.5 Z M17,3.5 C18.933,3.5 20.5,5.067 20.5,7 L20.5,9 C20.5,9.82843 19.8284,10.5 19,10.5 C18.1716,10.5 17.5,9.82843 17.5,9 L17.5,7 C17.5,6.72386 17.2761,6.5 17,6.5 L14,6.5 C13.1716,6.5 12.5,5.82843 12.5,5 C12.5,4.17157 13.1716,3.5 14,3.5 L17,3.5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default LanguageIcon;
